import React from "react";
import TopicGenerator from "./Components/Presentations/TopicGenerator.js";
import RandomImage from "./Components/Presentations/RandomImage.js";
import defaultImages from "./Components/Presentations/defaultImages";

export default function Presentations() {

  //See Codesandbox for code used to get defaultImages data.

  return (
    <div className="container">
      <div className="App">
        <h1 className="header">Presentations with Random Images</h1>
        <div className="row text-center px-5 py-4">
          <TopicGenerator />
          <RandomImage images={defaultImages} />
        </div>
      </div>
    </div>
  );
}
